import React from 'react';
import styles from './OfferSimulation.module.sass';
import ExpandArea from "../ui/ExpandArea/ExpandArea";
import RadioGroup from "../ui/RadioGroup/RadioGroup";
import Input from "../ui/Input/Input";
import Button from '../ui/Button/Button';
import validation from "../../utils/validation";
import api from "../../utils/api";
import currency from "../../utils/currency";
import KeyValueItem from "../ui/KeyValueItem/KeyValueItem";
import ordering from "../../utils/ordering";
import masks from "../../utils/masks";

class OfferSimulation extends React.Component {

  state = {
    open: false,
    simulationType: '',
    simulationValue: '',
    parcelas: [],
    openedIndex: -1
  };

  simulationRef = React.createRef();

  simulateHandler = () => {
    const input = document.getElementById("simulationValue");

    let validForm = true;
    let divToFocus;

    input.focus();
    input.blur();
    if (input.getAttribute("valid") === "false") {
      validForm = false;
      divToFocus = divToFocus ? divToFocus : input;
    }

    setTimeout(() => {
      if (input.getAttribute("valid") === "false") {
        validForm = false;
        divToFocus = divToFocus ? divToFocus : input;
      }

      if (validForm) {
        this.simulate();
      } else {
        divToFocus.scrollIntoView({behavior: "smooth", block: "start"});
      }
    }, 0);
  };

  simulate = () => {
    const requestBody = {
      codigoBem: this.props.oferta.codigoBem,
      codigoGrupo: this.props.oferta.identificacao.codigo,
      codigoPlano: this.props.oferta.dados.plano.identificacao.codigo,
      codigoVenda: this.props.oferta.identificacao.codigoVenda,
      codigoTaxa: this.props.oferta.dados.plano.identificacao.codigoTaxa,
      tipoOferta: this.state.simulationType,
      valor: this.state.simulationType === '%' ? this.state.simulationValue.replace('%', '') : currency.currencyToNumber(this.state.simulationValue)
    };

    api.get(api.endpoints.SIMULATION, null, requestBody).then((result) => {
      this.setState({parcelas: ordering.quotas(result.data)});
      this.simulationRef.scrollIntoView({behavior: "smooth", block: "start"})
    });
  };

  simulationTypeHandler = (value) => {
    if (value === '%') {
      this.setState({simulationType: value, simulationValue: '' + this.props.porcentagemLanceFixo + '%'});
    } else {
      this.setState({simulationType: value, simulationValue: ''});
    }
  };

  detailHandler = (index, state) => {
    this.setState({
      openedIndex: state ? index : -1
    });
  };

  newSimulationHandler = () => {
    this.setState({
      simulationType: '',
      simulationValue: '',
      parcelas: []
    });
  };

  render() {
    return (
      <ExpandArea
        open={this.state.open}
        onClick={() => this.setState({open: !this.state.open})}
        title='Quero simular um lance'
        container
      >
        <div ref={(el) => this.simulationRef = el} className={styles.OfferSimulation}>
          {
            this.state.parcelas.length > 0 ?
              (
                <React.Fragment>
                  <h2 className={styles.title}>Resultado da simulação:</h2>
                  {this.state.parcelas.map((el, index) => (
                    <ExpandArea
                      key={index}
                      index={index}
                      open={index === this.state.openedIndex}
                      onClick={this.detailHandler}
                      title={
                        el.inicio === el.fim
                          ? el.inicio + "ª parcela"
                          : "da " + el.inicio + "ª até a " + el.fim + "ª"
                      }
                    >
                      <div className={styles.parcelasInfo}>
                        <KeyValueItem
                          noDivider
                          Key={"Com lance"}
                          Value={'R$ ' + currency.numberToCurrency(el.valor)}
                        />
                        <KeyValueItem
                          noDivider
                          Key={"Sem lance"}
                          Value={'R$ ' + currency.numberToCurrency(this.props.parcelas[index].valor)}
                        />
                      </div>
                    </ExpandArea>
                  ))}
                  <p className={styles.bottomInfo}>
                    O valor do crédito e da parcela é corrigido a cada 12 assembleias do grupo, de acordo com o Índice
                    Nacional de Preços ao Consumidor – INPC, garantindo assim, o seu poder de compra.
                  </p>
                  <Button onClick={this.newSimulationHandler}>Fazer uma nova simulação</Button>
                </React.Fragment>
              ) :

              (
                <div className={styles.simulation}>
                  <h2 className={styles.title}>Simular por:</h2>
                  <RadioGroup
                    className={styles.radioSimulation}
                    options={['%', 'V'].map((el) => ({
                      text: el === '%' ? 'Lance fixo' : 'Lance livre',
                      value: el
                    }))}
                    value={this.state.simulationType}
                    onChanged={this.simulationTypeHandler}
                  >
                    ></RadioGroup>
                  <Input
                    value={this.state.simulationValue}
                    onChange={(value) => {
                      this.setState({simulationValue: value})
                    }}
                    typeDocument='Valor do lance'
                    readonly={this.state.simulationType !== 'V'}
                    validationRules={[validation.required, validation.greaterThan(0), validation.lessThan(this.props.credito)]}
                    mask={this.state.simulationType !== '%' && masks.currency}
                    validationTrigger='onChange'
                    id='simulationValue'
                  />
                  <Button onClick={this.simulateHandler}
                          disabled={this.state.simulationType.length === 0}>Simular</Button>
                </div>
              )
          }
        </div>
      </ExpandArea>
    );
  }
}

export default OfferSimulation;
